<template>
    <div class="rule">
        <div class="pros">1、首次反馈必得积分；</div>
        <div class="pros">2、非首次反馈，经审核具有价值平台将赠与相应的奖励！</div>
    </div>

</template>
<script>
    export default{
       data(){
         return{
         }
       },
       methods: {
       },


    }

</script>

<style lang="less" scoped>
   .pros{
    font-size: 1.6rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #1E1F22;
    line-height: 2.6rem;
   }
   .rule{
    padding: 1rem 2rem;
   }
</style>